import React from "react";
import { BannerView } from "./BannerView";
import { isAfterLocalTime, updateSessionStorage, loadContent } from "./helpers";

interface IState {
  show: boolean;
  content: { [key: string]: string };
}
class CrisisBanner extends React.Component<any, IState> {
  state = {
    show: false,
    content: {}
  };

  onCloseButtonClick = () => {
    updateSessionStorage("crisisBanner", { status: "close" });
    this.setState({ show: false });
  };

  displayBanner = async () => {
    const { status, content } = await loadContent("crisisBanner");
    if (status !== "open" || (content && !content.enabled)) {
      return;
    }
    const { start, end } = content;

    if (!isAfterLocalTime(start) && isAfterLocalTime(end)) {
      return this.setState({
        show: true,
        content: content
      });
    }
  };

  componentDidMount() {
    return this.displayBanner();
  }

  render() {
    const { show, content } = { ...this.state } as IState;
    return show ? (
      <BannerView
        type={content.type}
        heading={content.heading}
        message={content.msg}
        link={content.link}
        linkText={content.linkText}
        onCloseButtonClick={this.onCloseButtonClick}
        closeBtnDataId={"cbCloseBtn"}
      />
    ) : null;
  }
}

export default CrisisBanner;
